import type { ReactNode } from 'react';
import { TabMenu } from '@/_components/tab-menu/tab-menu';
import type { TabMenuOption } from '@/_components/tab-menu/types';
import { EMonitorTab, TRANSLATE_MONITOR_TAB } from '../../constants';
import type { MonitorTabCounts } from '../../types';
import styles from './status-tabs.module.scss';

interface MonitorStatusTabsProps {
  activeTab: EMonitorTab;
  counts?: MonitorTabCounts;
  onChange: (tab: EMonitorTab) => void;
  actions?: ReactNode;
}

const getTabText = (tab: EMonitorTab, counts?: MonitorTabCounts) => {
  const label = TRANSLATE_MONITOR_TAB[tab];

  return counts ? `${label} (${counts[tab]})` : label;
};

export function MonitorStatusTabs({
  activeTab,
  counts,
  onChange,
  actions,
}: MonitorStatusTabsProps) {
  const tabs: TabMenuOption<EMonitorTab>[] = Object.values(EMonitorTab).map(
    tab => ({ key: tab, value: tab, text: getTabText(tab, counts) }),
  );

  return (
    <div className={styles.statusTabs}>
      <TabMenu
        id="monitor-status-tabs"
        variant="segmented"
        tabs={tabs}
        activatedTab={activeTab}
        onChange={onChange}
        className={styles.tabs}
      />

      {actions && <div className={styles.actions}>{actions}</div>}
    </div>
  );
}
